import { investorApi } from '@core/api/httpClient'
import { PROPERTY_ENDPOINTS } from './propertyEndpointPaths'
import type { PropertyDetailResponseDto } from './propertyDetailContracts'

export async function getPropertyDetail(propertyId: string): Promise<PropertyDetailResponseDto> {
  const { data } = await investorApi.get<PropertyDetailResponseDto>(
    PROPERTY_ENDPOINTS.PROPERTY_DETAIL.replace('{offeringId}', propertyId),
  )
  return data
}
